
import AddProductForm from './AddProductForm';
import AddCategoryForm from './AddCategoryForm';
import "./products_form.css";
import Dashboard_Products from './Dashboard_Products';

export default function ProductForm({website, setEditPage}) {
    return (
        <div className='dashboardForm' style={{backgroundColor:`${website.settings.theme.secondary_color}`}}>
            <AddCategoryForm website={website}/>
            {website?.settings?.categories?.length>0 && <AddProductForm website={website}/>}
            {website?.settings?.categories?.length>0 && <Dashboard_Products website={website} setEditPage={setEditPage}/>}
        </div>
    )
}
